import API from '../../api';

const API_URI = '/v1/worker_occupation_companies';

export default {
  getAll(params, callback) {
    return API.get(API_URI, params, callback);
  }
}
